<template>
  <div class="wt-text-overlay-grids-bar">
    <span
      class="wt-show-grid"
      :class="{ 'wt-active': generalGridActive }"
      title="Toggle Grid"
      @click="toggleGeneralGrid"
    >
      <i class="wticon wticon-wochit-grid" />
    </span>
    <span
      v-if="hasNowThisGrid"
      class="wt-show-grid"
      :class="{ 'wt-active': nowThisGridActive }"
      title="Toggle Grid"
      @click="toggleNowThisGrid"
    >
      <i class="wticon wticon-grid2" />
    </span>
  </div>
</template>

<script>
import app from 'app';
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters('assetEditor', ['pageTmpState', 'story']),

    hasNowThisGrid: function () {
      return (
        this.story.programmer.enableGridInAssetEditor &&
        this.story.aspectRatio.name === 'ASPECT_16_9'
      );
    },

    nowThisGridActive: function () {
      return !!this.pageTmpState.showNowThisGrid;
    },

    generalGridActive: function () {
      return !!this.pageTmpState.showGeneralGrid;
    },
  },

  mounted: function () {
    if (this.hasNowThisGrid && app.stash.get('showNowThisGrid')) {
      this.toggleNowThisGrid();
    }
    if (!this.nowThisGridActive && app.stash.get('showGeneralGrid')) {
      this.toggleGeneralGrid();
    }
  },

  methods: {
    ...mapMutations('assetEditor', ['setTmpPageState']),

    toggleNowThisGrid: function () {
      const showNowThisGrid = !this.pageTmpState.showNowThisGrid;
      if (this.generalGridActive) {
        this.toggleGeneralGrid();
      }
      this.setTmpPageState({ showNowThisGrid });
      app.stash.set('showNowThisGrid', showNowThisGrid);
    },

    toggleGeneralGrid: function () {
      const showGeneralGrid = !this.pageTmpState.showGeneralGrid;
      if (this.nowThisGridActive) {
        this.toggleNowThisGrid();
      }
      this.setTmpPageState({ showGeneralGrid });
      app.stash.set('showGeneralGrid', showGeneralGrid);
    },
  },
};
</script>
